<template>
  <div class="container-fluid">
    <div class="loading" v-if="loading">Loading&hellip;</div>

    <div class="view-header my-4">
      <div class="view-header__main">
        <div class="view-header__info">
          <h1 class="view-header__title">Cheques propios</h1>
          <p class="view-header__subtitle">Cheques emitidos por la empresa, su estado y movimientos.</p>
        </div>
        <div class="view-header__actions">
          <button type="button" class="btn view-header__btn view-header__btn--primary" @click="openModal">
            <i class="bi bi-plus-lg"></i>
            Nuevo cheque
          </button>
        </div>
      </div>
    </div>

    <!-- BALANCE -->
    <div class="stats-card">
      <div class="stats-card__value">{{ formatoDinamicoMoneda(balanceCheques) }}</div>
      <div class="stats-card__label">Monto total de cheques propios en cartera</div>
    </div>

    <!-- FILTROS -->
    <div class="filters-panel">
      <div class="filters-panel__section">
        <div class="filters-panel__row">
          <div class="filters-panel__field">
            <input v-model="doSearch" type="search" class="form-control" placeholder="Buscar cheque...">
          </div>
          <div class="filters-panel__field filters-panel__field--inline">
            <label class="control-label">Fecha de emisión:</label>
            <Daterange ref="emision" :opendir="'right'" @datepicked="(date) => dateCreated('emision', date)" />
          </div>
          <div class="filters-panel__field filters-panel__field--inline">
            <label class="control-label">Fecha de cobro:</label>
            <Daterange ref="cobro" :opendir="'right'" @datepicked="(date) => dateCreated('cobro', date)" />
          </div>
          <div class="filters-panel__field">
            <q-select v-model.number="checksFilter" :options="checksFilterOptions" />
          </div>
          <div class="filters-panel__field">
            <q-select v-model="kindFilter" :options="kindFilterOptions" />
          </div>
          <div class="filters-panel__actions">
            <button
              type="button"
              class="filters-panel__btn filters-panel__btn--primary"
              :disabled="!buttonBatchDeposit"
              @click="batchDeposit"
            >
              <i class="bi bi-bank"></i>
              Depositar en lote
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- TABLA -->
    <div class="data-table">
      <vdtnet-table
        ref="table"
        :fields="fields"
        :opts="opts"
        :selectCheckbox="1"
        container-class-name="table-responsive"
        class-name="table mb-0"
        @edit="changefs_checkId"
        @cash="showCashCheckModal"
        @delete="deleteCheck"
        @row-select="selectedCheck"
        @row-deselect="deselectedCheck"
      />
    </div>

    <!-- MODAL DEPÓSITO INDIVIDUAL -->
    <DepositModal
      v-if="showModal"
      :funds="funds"
      @fundSelected="depositForm"
      @close="showModal = false"
    />

    <!-- MODAL DEPÓSITO EN LOTE -->
    <DepositModal
      v-if="showMultipleModal"
      :funds="funds"
      @fundSelected="multiDepositForm"
      @close="showMultipleModal = false"
    />

    <!-- MODAL NUEVO / EDITAR CHEQUE -->
    <transition name="modal">
      <div v-if="showNewCheckModal" class="modal-mask-product">
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="form-card__header">
              <h6 class="form-card__title">
                <i class="bi bi-receipt"></i>
                {{ checkIdParent ? 'Editar cheque' : 'Nuevo cheque propio' }}
              </h6>
              <button type="button" class="form-card__btn" @click="close()">
                <i class="bi bi-x-lg"></i>
              </button>
            </div>
            <div class="modal-body">
              <Nuevochequepropio
                :checkId="checkIdParent"
                @reset-id="checkIdParent = null"
                @confirmsave="modalSucess()"
              />
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import VdtnetTable from '@/components/global/VdtnetTable.vue';
import Daterange from "../global/Daterange-component.vue";
import DepositModal from "../sub-components/depositModal.vue";
import formatMoneyMixin from "../../mixins/formatMoneyMixin";
import formatDateMixin from "../../mixins/formatDateMixin";
import Nuevochequepropio from "./../sub-components/Nuevo-cheque-propio.vue";
import QSelect from '@/components/shared/QSelect.vue';
import { CHECK_KIND_LABELS } from "../../constants/checkKind";

export default {
  components: {
    VdtnetTable,
    Nuevochequepropio,
    Daterange,
    DepositModal,
    QSelect,
  },
  mixins: [formatMoneyMixin, formatDateMixin],
  data: function () {
    return {
      doSearch: "",
      loading: false,
      checkIdParent: null,
      showNewCheckModal: false,
      showModal: false,
      showMultipleModal: false,
      depositCheckId: null,
      checks: [],
      funds: [],
      checksFilter: 2,
      kindFilter: "",
      startDate: null,
      endDate: null,
      startDate2: null,
      endDate2: null,
      issue: false,
      selectedIndexes: [],
      opts: {
        language: {
          url: '//cdn.datatables.net/plug-ins/1.13.4/i18n/es-ES.json',
        },
        ajax: this.getChecks,
        serverSide: false,
        ordering: true,
        order: [],
        searching: true,
        autoWidth: false,
        select: { style: "multi" },
      },
      fields: {
        id: { visible: false },
        name: {
          label: "Nombre emisor",
          searchable: true,
          defaultContent: "Ninguno",
          render: (data, type) =>
            type === 'display' ? `<span class="data-table__primary">${data || 'Ninguno'}</span>` : data,
        },
        number: { label: "Número", searchable: true },
        date_issue: { label: "Emisión", searchable: true },
        date_due: { label: "Cobro", searchable: true },
        origen: {
          label: "Orígen",
          defaultContent: "Ninguno",
          searchable: true,
        },
        amount: {
          label: "Monto",
          searchable: true,
          align: "right",
          render: this.formatoDinamicoMoneda,
        },
        status: { label: "Estado", searchable: true },
        provider: { label: "A proveedor", searchable: true },
        check_kind: {
          label: "Tipo",
          searchable: true,
          render: (data, type) =>
            type === 'display'
              ? `<span class="badge badge-${data === 'echeq' ? 'info' : 'secondary'}">${CHECK_KIND_LABELS[data] || 'Físico'}</span>`
              : data,
        },
        actions: {
          isLocal: true,
          label: "Acciones",
          width: "120px",
          align: "right",
          render: (_data, _type, row) => {
            if (!row.action) return '';
            return `
              <div class="table-action-group">
                <button data-action="edit" class="table-action-btn" type="button" title="Editar">
                  <i class="bi bi-pencil"></i>
                </button>
                <button data-action="cash" class="table-action-btn" type="button" title="Cobrar / Depositar">
                  <i class="bi bi-bank"></i>
                </button>
                <button data-action="delete" class="table-action-btn" type="button" title="Borrar">
                  <i class="bi bi-trash"></i>
                </button>
              </div>
            `;
          },
        },
      },
    };
  },
  watch: {
    doSearch(newValue, oldValue) {
      if (newValue.length >= 4 || oldValue.length >= 4) {
        this.$refs.table.search(this.doSearch);
      }
      if (newValue === "" && oldValue.length > 0) {
        this.$refs.table.search(this.doSearch);
      }
    },
    checksFilter() {
      this.refreshTable();
    },
    kindFilter(value) {
      const dt = this.$refs.table && this.$refs.table.dataTable;
      if (!dt) return;
      dt.column('check_kind:name').search(value ? `^${value}$` : '', true, false).draw();
    },
    daterange() {
      this.refreshTable();
    },
  },
  computed: {
    balanceCheques() {
      if (!this.checks) return 0;
      return this.checks.reduce((acc, c) => acc + Number(c.amount), 0);
    },
    daterange() {
      if (this.startDate === null && this.startDate2 === null) {
        return null;
      }
      if (this.startDate != null) {
        const startDate = this.formatoFecha2Daterange(this.startDate);
        const endDate = this.formatoFecha2Daterange(this.endDate);
        return true + ' ' + `${startDate} - ${endDate}`;
      } else {
        const startDate = this.formatoFecha2Daterange(this.startDate2);
        const endDate = this.formatoFecha2Daterange(this.endDate2);
        return false + ' ' + `${startDate} - ${endDate}`;
      }
    },
    selectedCheckIds() {
      return this.selectedIndexes.map((index) => this.checks[index].id);
    },
    buttonBatchDeposit() {
      return this.selectedIndexes.length > 1;
    },
    checksFilterOptions() {
      return [
        { value: 0, label: 'Todos los cheques' },
        { value: 1, label: 'Sólo sin depositar' },
        { value: 2, label: 'Sólo en cartera' },
        { value: 3, label: 'Sólo depositados' },
        { value: 4, label: 'Pagados a proveedor' },
      ];
    },
    kindFilterOptions() {
      return [
        { value: '', label: 'Todos' },
        { value: 'fisico', label: 'Físico' },
        { value: 'echeq', label: 'eCheq' },
      ];
    },
  },
  methods: {
    dateCreated(range, date) {
      if (range === 'emision') {
        this.startDate = date.startDate;
        this.endDate = date.endDate;
      } else if (range === 'cobro') {
        this.startDate2 = date.startDate;
        this.endDate2 = date.endDate;
      }
    },
    openModal() {
      this.showNewCheckModal = true;
    },
    close() {
      this.showNewCheckModal = false;
    },
    modalSucess() {
      this.close();
      this.refreshTable();
    },
    depositForm(fundId) {
      this.showModal = false;
      this.loading = true;
      const depositData = {
        fund_id: fundId,
        check_id: this.depositCheckId,
      };
      this.$http.post("/api/funds/checks/deposit", depositData).then((response) => {
        this.loading = false;
        if (response.data.code == 201) {
          this.refreshTable();
        }
      });
    },
    multiDepositForm(fundId) {
      this.showMultipleModal = false;
      this.loading = true;
      const depositData = {
        fund_id: fundId,
        check_id: this.selectedCheckIds.join(),
      };
      this.$http.post("/api/funds/checks/multideposit", depositData).then((response) => {
        this.loading = false;
        if (response.data.code == 201) {
          this.selectedIndexes = [];
          this.refreshTable();
        }
      });
    },
    deleteCheck(data) {
      if (!confirm("¿Está seguro que desea borrar este cheque?")) return;
      this.$http.post("/api/funds/checks/delete", { id: data.id }).then((response) => {
        if (response.data.code == 201) {
          this.refreshTable();
        }
      });
    },
    getChecks(d, cb) {
      this.$http
        .get("/api/funds/checks/list", {
          params: {
            status: this.checksFilter,
            daterange: this.daterange,
          },
        })
        .then((response) => {
          this.checks = response.data.data;
          cb(response.data);
        });
    },
    changefs_checkId(data) {
      this.checkIdParent = data.id;
      this.openModal();
    },
    showCashCheckModal(data) {
      this.depositCheckId = data.id;
      this.showModal = true;
    },
    getFunds() {
      this.$http.get("/api/funds/listSimple").then((response) => {
        this.funds = response.data.data;
      });
    },
    refreshTable() {
      if (this.$refs.table !== undefined) this.$refs.table.reload();
    },
    selectedCheck({ indexes }) {
      if (indexes.length !== this.checks.length) {
        indexes.forEach((element) => {
          if (!this.selectedIndexes.includes(element)) {
            this.selectedIndexes.push(element);
          }
        });
        return;
      }
      this.selectedIndexes = indexes;
    },
    deselectedCheck({ indexes }) {
      if (indexes.length !== this.checks.length) {
        indexes.forEach((element) => {
          const posicion = this.selectedIndexes.findIndex((indice) => indice === element);
          if (posicion != -1) {
            this.selectedIndexes.splice(posicion, 1);
          }
        });
        return;
      }
      this.selectedIndexes = [];
    },
    batchDeposit() {
      if (!this.buttonBatchDeposit) return;
      if (confirm("Se depositaran " + this.selectedIndexes.length + " cheques") == true) {
        this.showMultipleModal = true;
      }
    },
  },
  mounted() {
    this.getFunds();
    this.$nextTick(() => {
      const dt = this.$refs.table && this.$refs.table.dataTable;
      if (!dt) return;
      dt.on('preXhr.dt', () => { this.loading = true; });
      dt.on('xhr.dt', () => { this.loading = false; });
      dt.on('user-select', (e, table, type, cell) => {
        const status = table.row(cell.node()).data().DT_RowClass;
        if (status !== 'reactive') return false;
        return true;
      });
    });
  },
};
</script>

<style scoped>
.filters-panel__field--inline {
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 0 0 auto;
}

.filters-panel__field--inline .control-label {
  margin: 0;
  white-space: nowrap;
  font-size: 13px;
  color: var(--text);
}

.filters-panel__field--inline > .form-group {
  flex: 0 0 auto;
  margin-bottom: 0;
}

.modal-mask-product {
  position: fixed;
  z-index: 1050;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(16, 24, 40, 0.45);
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding: 24px;
  overflow-y: auto;
}

.modal-dialog {
  margin: 0;
  width: 100%;
  max-width: 560px;
}

.modal-content {
  border: 1px solid var(--border-soft);
  border-radius: 12px;
  box-shadow: 0 12px 32px rgba(16, 24, 40, 0.18);
  overflow: hidden;
  background: var(--surface);
}

.modal-body {
  max-height: 80vh;
  overflow-y: auto;
  padding: 0;
}

.modal-enter,
.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-content,
.modal-leave-active .modal-content {
  transform: scale(1.02);
}
</style>
